<template>
  <div>
    <HelloWorld />
    <FirstComp />
  </div>
</template>

<script>
import HelloWorld from '../components/HelloWorld.vue';
import FirstComp from '../components/FirstComp.vue';

export default {
  components: {
    HelloWorld,
    FirstComp,
  },
};
</script>
